import { useTranslation } from "react-i18next";
import type { UsageInfoResponse } from "@/domain/aiAgent";
import { cn } from "@/utils";

interface AiAgentUsageBarProps {
	usageInfo: UsageInfoResponse | null | undefined;
	quotaExceeded: boolean;
}

export const AiAgentUsageBar = ({
	usageInfo,
	quotaExceeded,
}: AiAgentUsageBarProps) => {
	const { t } = useTranslation();

	if (!usageInfo) return null;

	const pct = Math.min(Math.round(usageInfo.pct_used), 100);
	const isExceeded = quotaExceeded || pct >= 100;
	const isWarning = pct >= 80;
	const isNotice = pct >= 60;

	const fillClass = isExceeded
		? "ai-chat-usage-fill--exceeded"
		: isWarning
			? "ai-chat-usage-fill--warning"
			: isNotice
				? "ai-chat-usage-fill--notice"
				: "";

	return (
		<div className="ai-chat-usage-bar">
			<div className="ai-chat-usage-track">
				<div
					className={cn("ai-chat-usage-fill", fillClass)}
					style={{ width: `${isExceeded ? 100 : pct}%` }}
				/>
			</div>
			<div
				className={cn(
					"ai-chat-usage-row",
					isExceeded ? "ai-chat-usage-row--exceeded" : "",
				)}
			>
				<span>
					{isExceeded
						? t("agent.usage_exceeded")
						: t("agent.usage_label", { used: usageInfo.queries_today })}
				</span>
				{isNotice && !isExceeded && <span>{pct}%</span>}
			</div>
		</div>
	);
};
